import { invoke } from "@shared/easyfy.decorators";
import Toggle from '@shared/easyfy.toggle';
import DropDown from '@webModules/dropdown';
import Basket from '@webModules/basket';
import Events, { ServiceNames } from "@shared/easyfy.events/easyfy.eventhandler";
import { Ga4DataMapper } from "@shared/easyfy.events/mappers/dataMapper.ga4";
import { StatsDataMapper } from "@shared/easyfy.events/mappers/dataMapper.stats";
import { IDataMapper } from "@shared/easyfy.events/easyfy.eventdata";
import Search, { SearchConfig } from '@webModules/search';
import '@webModules/form';
import '@clientWebModules/minibasket';
import '@clientWebModules/headermenu';

namespace Easyfy.Page {
  @invoke
  class Global {
    private toggle: Toggle;

    constructor() {

    }

    onInit() {
      this.toggle = new Toggle('toggle');
      new Search.Search(new SearchConfig(2, true, false, false, false, true, 'grid')).OnInit();
      new DropDown.Dropdown();
      Basket.Basket.getBasket();
      new Events.EasyfyEventHandler(new Map<string, IDataMapper>([
        [ServiceNames.Ga4, new Ga4DataMapper()],
        [ServiceNames.Stats, new StatsDataMapper()]
      ]));
    }
  }
}